import { render, staticRenderFns } from "./Appearance.vue?vue&type=template&id=4f7066cf"
import script from "./Appearance.vue?vue&type=script&lang=js"
export * from "./Appearance.vue?vue&type=script&lang=js"
import style0 from "./Appearance.vue?vue&type=style&index=0&id=4f7066cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports